var Handlebars = require("../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<span class=\"FV-subHeader-title\">Find And Redact</span>\n\n\n\n<div id=\"fr-spinner-region\"></div>";
},"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/header/template.hbs
 ** module id = 590
 ** module chunks = 0
 **/